<template>
    <div class="alert alert-warning" role="alert">
        <h4 class="alert-heading">{{ $t('components.specialOffer.title') }}</h4>
        <p v-html="specialOffer.content"></p>
    </div>
</template>

<script>
export default {
    name: 'SpecialOffer',
    props: {
        specialOffer: {
            type: String,
            required: true,
            default: "No content specified!"
        }
    }
}
</script>

<style lang="scss" scoped>
 .alert.alert-warning {
    background-color: $softest-red;
    border: 0;
 }

 .alert.alert-warning h4 {
    color: $soft-red;
 }
</style>